import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import { setChonkyDefaults, ChonkyActions } from 'chonky';
import { ChonkyIconFA } from 'chonky-icon-fontawesome';

import reportWebVitals from './reportWebVitals';
import store from 'Components/app/store';
import App from 'App';

const root = ReactDOM.createRoot(document.getElementById('root'));

setChonkyDefaults({ iconComponent: ChonkyIconFA, defaultFileViewActionId: ChonkyActions.EnableListView.id });

root.render(<React.StrictMode>
  <Provider store={store}>        
      <App />
  </Provider>
</React.StrictMode>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
